module.exports = __webpack_public_path__ + "static/img/image005.299c170.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news7/image005.png
// module id = wKrt
// module chunks = 1